import React, { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../../components/LoginGate';
import { useProducts } from '../entitlements/useProducts';
import ProductTabBar from './ProductTabBar';
import EntitlementRedirect from './EntitlementRedirect';
import ProtectedProduct from './ProtectedProduct';
import './platform.css';

const CoreProduct    = React.lazy(() => import('../../products/core'));
const RESuiteProduct = React.lazy(() => import('../../products/re-suite'));

function ProductSpinner() {
  return (
    <div className="product-loading">
      <div className="product-loading-spinner" />
    </div>
  );
}

export default function PlatformShell() {
  const { user } = useAuth();
  const products = useProducts();

  return (
    <div className="platform-shell">
      {products.length > 1 && <ProductTabBar products={products} />}
      <div className="platform-content">
        <Suspense fallback={<ProductSpinner />}>
          <Routes>
            <Route
              path="/app/core/*"
              element={
                <ProtectedProduct id="core" products={products}>
                  <CoreProduct />
                </ProtectedProduct>
              }
            />
            <Route
              path="/app/re-suite/*"
              element={
                <ProtectedProduct id="re_suite" products={products}>
                  <RESuiteProduct />
                </ProtectedProduct>
              }
            />
            <Route path="*" element={<EntitlementRedirect products={products} />} />
          </Routes>
        </Suspense>
      </div>
    </div>
  );
}
